import { UserSessionContext } from 'components/UserSession';
import { useContext, useMemo } from 'react';
import { stringifyUrl } from 'query-string';

const useEncodedLiveWebinarUrl = (webinarName: string, webinarUrl: string) => {
  const { userSession } = useContext(UserSessionContext);
  const trackingInfo = {
    user_email: userSession.email,
    user_token: userSession.authToken,
    user_first_name: userSession.firstName || '',
    user_last_name: userSession.lastName || '',
    user_phone: userSession.phone || '',
    user_uuid: userSession.uuid || '',
    user_company: userSession.company || '',
    user_title: userSession.title || '',
    user_role: userSession.role || '',
    webinar_name: webinarName || '',
  };
  return useMemo(() => stringifyUrl({
    url: webinarUrl ?? '',
    query: {
      trackingParam: window.btoa(unescape(encodeURIComponent(JSON.stringify(trackingInfo)))),
    },
  }), [webinarUrl, trackingInfo]);
};

export default useEncodedLiveWebinarUrl;
